var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"px-4 tablet-landscape:px-0"},[(_setup.isSmallerThanTabletLandscape)?_c(_setup.OzBaseButton,{class:['w-full', 'bg-transparent', 'py-3', 'group'],on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return (() => (_setup.isOpen = !_setup.isOpen)).apply(null, arguments)}}},[_c('div',{class:[
        'flex items-center',
        'space-x-3',
        'ps-0.5 pe-1',
        'text-dark-text-200 dark:text-light-text-200 text-body',
        'hover-hover:hover:text-dark-text-100 hover-hover:dark:hover:text-light-text-100',
        'group-active:text-grape-500 dark:group-active:text-canary-500',
      ]},[_c('span',{staticClass:"flex flex-1 font-semibold"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c(_setup.OzIcon,{attrs:{"name":_setup.isOpen ? 'chevron_up' : 'chevron_right_center',"size":14}})],1)]):_c('h2',{class:[
      'flex',
      'ps-0.5 mb-2',
      'text-dark-text-200 dark:text-light-text-200',
      'text-17 desktop-3xl:text-heading-2',
      'font-semibold',
    ]},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),(!_setup.isSmallerThanTabletLandscape || _setup.isOpen)?_c('div',_vm._l((_vm.navigationItems),function(navigationItem,index){return _c(_setup.OzBaseButton,{key:index,class:[
        'block w-fit bg-transparent',
        'py-3 tablet-landscape:py-1 tablet-landscape:px-2 tablet-landscape:-ms-2',
        'focus-visible:outline-none',
        'rounded-lg',
        'focus-visible:ring-2',
        'hover-hover:focus-visible:ring-grape-500 hover-hover:dark:focus-visible:ring-canary-500',
        'group',
      ],attrs:{"href":navigationItem.url}},[_c('span',{class:[
          'flex',
          'ps-0.5 pe-5 tablet-landscape:pe-0',
          'text-dark-text-200 dark:text-light-text-200 text-body tablet-landscape:text-body-small-posts',
          'hover-hover:hover:text-dark-text-100 hover-hover:dark:hover:text-light-text-100',
          'group-active:text-grape-500 dark:group-active:text-canary-500',
        ]},[_vm._v("\n        "+_vm._s(navigationItem.name)+"\n      ")])])}),1):_vm._e(),_vm._v(" "),(_setup.isSmallerThanTabletLandscape)?_c(_setup.OzDivider,{attrs:{"color-scheme":_setup.OzDividerColorScheme.Solid}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }